import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExpertMarketplaceCTA = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-lg p-6 md:p-8 border border-primary/20">
      <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
        <div className="flex-shrink-0">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-primary/20 rounded-full flex items-center justify-center">
            <Icon name="Users" size={32} color="var(--color-primary)" />
          </div>
        </div>
        
        <div className="flex-1">
          <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-2">
            Need Expert Review?
          </h3>
          <p className="text-base md:text-lg text-muted-foreground mb-4">
            This preliminary AI analysis provides a foundation for your case. For comprehensive human expert review, connect with certified fire forensics professionals through our marketplace.
          </p>
          
          <div className="flex flex-wrap gap-3">
            <Button
              variant="default"
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => navigate('/expert-marketplace-listing')}
            >
              Browse Expert Marketplace
            </Button>
          </div>
        </div>
      </div>
      
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="flex items-start gap-3">
            <Icon name="Shield" size={20} className="text-success flex-shrink-0 mt-1" />
            <div>
              <div className="font-medium text-sm text-foreground">Verified Credentials</div>
              <div className="text-xs text-muted-foreground">All experts vetted and certified</div>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <Icon name="Lock" size={20} className="text-success flex-shrink-0 mt-1" />
            <div>
              <div className="font-medium text-sm text-foreground">Secure Escrow</div>
              <div className="text-xs text-muted-foreground">Protected payment system</div>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <Icon name="MessageCircle" size={20} className="text-success flex-shrink-0 mt-1" />
            <div>
              <div className="font-medium text-sm text-foreground">In-App Messaging</div>
              <div className="text-xs text-muted-foreground">Direct communication platform</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertMarketplaceCTA;